import { render, staticRenderFns } from "./statusBlock.vue?vue&type=template&id=2d764a6e&"
import script from "./statusBlock.vue?vue&type=script&lang=js&"
export * from "./statusBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports